<template>
    <div>
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-12 p-0">
                <div class="card shadow-sm">
                    <div class="card-header">
                        <p class="text-center" style="margin: 0px;">ตรวจสอบรายละเอียดการกู้</p>
                    </div>
                    <div class="card-body">
                        <template>
                            <p class="font-weight-bold">สินเชื่อเงินสด NIMCAP</p>
                            <p>จำนวนที่ขอสินเชื่อ <strong>10,000 บาท</strong></p>
                        </template>
                        <template>
                            <p class="font-weight-bold">ผ่อนชำระรายสัปดาห์</p> 
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td>อัตราดอกเบี้ยลดต้นลดดอก</td>
                                        <td>15% ต่อปี</td>
                                    </tr>
                                    <tr>
                                        <td>ค่าธรรมเนียมการใช้วงเงิน</td>
                                        <td>0.75%</td>
                                    </tr>
                                    <tr>
                                        <td>ค่าอากรแสตมป์</td>
                                        <td>0.05%</td>
                                    </tr>
                                    <tr>
                                        <td>ระยะเวลาผ่อนชำระ</td>
                                        <td>90 วัน</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template>
                            <p class="font-weight-bold">ยอดผ่อนชําระ 275.73 บาท/สัปดาห์</p> 
                        </template>
                       <template>
                            <p class="font-weight-bold">รับเงินใน : บัญชีธนาคาร</p>
                       </template> 
                       <template>
                            <p class="font-weight-bold">วิธีชำระคืน</p> 
                            <ul style="margin-left: 1rem;">
                                <li>BeNeat จะหักเงินคืนจากรายได้ประจำสัปดาห์ ตามตารางการผ่อนชำระ</li>
                                <li>ถ้าหากรายได้ประจำสัปดาห์ไม่เพียงพอ จะรวบยอด กับการเรียกเก็บในสัปดาห์ต่อไป</li>
                            </ul>
                       </template>
                    </div>
                </div>
                <div class="card shadow-sm">
                    <div class="card-body">
                        <p>ขั้นตอนสุดท้าย! กรุณากรอกข้อมูลส่วนตัวของคุณ เพื่อใช้พิจารณาให้สินเชื่อ</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
  methods: {
    nextPage () {
      this.$emit('next')
    }
  }
}
</script>
<style scoped>
.list-style {
    list-style-type: circle;
}
</style>


// WEBPACK FOOTER //
// src/components/nimcap/Components/Guarantor/Step8.vue